export const DeleteKnownIssuesDialogTitle = "Delete Issues";
export const DeleteKnownIssuesDialogMessage = "Are you sure you want to delete this issue?";
